<div>
    <div class="c-content-section">

        <div class="outerDiv">
			<div class="leftDiv">
				<h5 class="c-label"> First Group </h5>
			</div>
			<div class="rightDiv">
				<ccl-toggle-button
            [title]="assetConfig.enableFirstGroup ? 'Enable' : 'Disable'"
            [isChecked]="assetConfig.enableFirstGroup"
            (isCheckedChange)="toggleHTMLEnable($event,'enableFirstGroup')"
            >{{ assetConfig.enableFirstGroup ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
			</div>		
			<div style="clear:both"></div>
		</div>
<div *ngIf="assetConfig.enableFirstGroup">
  <div class="c-form-group">
      <div class="c-form-group__label"><label for="filterLabel">Group Label</label></div>
      <input id="filterLabel" class="c-form-group__input" [(ngModel)]="assetConfig.firstGroupLabel" cclFormInput maxlength="20" />
      <div class="c-form-group__hint">&nbsp;</div>
  </div>
  <div class="c-form-group__label"><label for="filterLabel">Assets</label></div>
  <div class="c-form-group">
      <div class="c-form-group__label"><label for="displayOptionDropdown"></label></div>
      <div class="flex-100 w100">
          <div ngbDropdown class="d-inline-block w100">
              <button class="btn c-form-group__input text-left w100" id="displayOptionDropdown" ngbDropdownToggle>
                  {{
                    assetConfig.firstGroupList.length != 0
                          ? "Selected : " +
                          assetConfig.firstGroupList.length + " " +
                          assetConfig.firstGroupLabel
                          : "No File Selected"
                  }}
              </button>
              <div
                  ngbDropdownMenu
                  aria-labelledby="displayOptionDropdown"
                  class="w100 displayOptionDropdownContent"
                  (click)="$event.stopPropagation()"
              >
                  <div class="col-sm-12">
                      <div *ngIf="firstassetList.length > 0">
                          <div class="col-sm-12 plr0">
                              <ccl-checkbox
                                  class="text-capitalize"
                                  *ngFor="let field of firstassetList"
                                  [hidden]="field.show == false"
                                  buttonStyle="c-checkbox"
                                  (clickEvent)="onChange(field,'firstGroupList')"
                                  [id]="field.key"
                                  [value]="getIndex(assetConfig.firstGroupList,field)"
                                  >{{ field.label }}</ccl-checkbox
                              >
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="c-form-group__hint">&nbsp;</div>
  </div>
  <div class="c-form-group" *ngIf="assetConfig.firstGroupList.length>0">
      <div class="flex-100 filterTypeContainer" ngxDroppable [model]="assetConfig.firstGroupList">
          <div
              class="filterTypeContainerItem text-capitalize ngx-dnd-container"
              *ngFor="let field of assetConfig.firstGroupList; let i = index"
              ngxDraggable
              [model]="field"
          >
              <span>{{
                  field.label
              }}</span>
              <span (cclClick)="removeFields(i, assetConfig.firstGroupList, 'firstGroupList', field.value)"><i class="fa fa-remove removeIcon" title="Remove"></i></span>
              <span class="c-draghandle-icon filter-drag-icon" ngxDragHandle>
                  <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
                  <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
              </span>
          </div>
      </div>
      <div class="c-form-group__hint">&nbsp;</div>
  </div>
  </div>
</div>
<div class="c-content-section">
    <div class="outerDiv">
        <div class="leftDiv">
            <h5 class="c-label"> Second Group </h5>
        </div>
        <div class="rightDiv">
            <ccl-toggle-button
        [title]="assetConfig.enableSecondGroup ? 'Enable' : 'Disable'"
        [isChecked]="assetConfig.enableSecondGroup"
        (isCheckedChange)="toggleHTMLEnable($event,'enableSecondGroup')"
        >{{ assetConfig.enableSecondGroup ? "Enabled" : "Disabled" }}</ccl-toggle-button
    >
        </div>		
        <div style="clear:both"></div>
    </div>
    <div *ngIf="assetConfig.enableSecondGroup">
  <div class="c-form-group">
    <div class="c-form-group__label"><label for="filterLabel">Group Label</label></div>
    <input id="filterLabel" class="c-form-group__input" [(ngModel)]="assetConfig.secondGroupLabel" cclFormInput maxlength="20" />
    <div class="c-form-group__hint">&nbsp;</div>
</div>
<div class="c-form-group__label"><label for="filterLabel">Assets</label></div>
<div class="c-form-group">
    <div class="c-form-group__label"><label for="displayOptionDropdown"></label></div>
    <div class="flex-100 w100">
        <div ngbDropdown class="d-inline-block w100">
            <button class="btn c-form-group__input text-left w100" id="displayOptionDropdown" ngbDropdownToggle>
                {{
                  assetConfig.secondGroupList.length != 0
                        ? "Selected : " +
                        assetConfig.secondGroupList.length + " " +
                        assetConfig.secondGroupLabel
                        : "No File Selected"
                }}
            </button>
            <div
                ngbDropdownMenu
                aria-labelledby="displayOptionDropdown"
                class="w100 displayOptionDropdownContent"
                (click)="$event.stopPropagation()"
            >
                <div class="col-sm-12">
                    <div *ngIf="secondAssetList.length > 0">
                        <div class="col-sm-12 plr0">
                            <ccl-checkbox
                                class="text-capitalize"
                                *ngFor="let field of secondAssetList"
                                [hidden]="field.show == false"
                                buttonStyle="c-checkbox"
                                (clickEvent)="onChange(field,'secondGroupList')"
                                [id]="field.key"
                                [value]="getIndex(assetConfig.secondGroupList,field)"
                                >{{ field.label }}</ccl-checkbox
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="c-form-group__hint">&nbsp;</div>
</div>
<div class="c-form-group" *ngIf="assetConfig.secondGroupList.length>0">
    <div class="flex-100 filterTypeContainer" ngxDroppable [model]="assetConfig.secondGroupList">
        <div
            class="filterTypeContainerItem text-capitalize ngx-dnd-container"
            *ngFor="let field of assetConfig.secondGroupList; let i = index"
            ngxDraggable
            [model]="field"
        >
            <span>{{
                field.label
            }}</span>
            <span (cclClick)="removeFields(i, assetConfig.secondGroupList, 'secondGroupList', field.value)"><i class="fa fa-remove removeIcon" title="Remove"></i></span>
            <span class="c-draghandle-icon filter-drag-icon" ngxDragHandle>
                <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
                <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
            </span>
        </div>
    </div>
    <div class="c-form-group__hint">&nbsp;</div>
</div>
</div>
</div>
<div class="c-content-section">
    <div class="outerDiv">
        <div class="leftDiv">
            <h5 class="c-label"> Third Group </h5>
        </div>
        <div class="rightDiv">
            <ccl-toggle-button
        [title]="assetConfig.enableThirdGroup ? 'Enable' : 'Disable'"
        [isChecked]="assetConfig.enableThirdGroup"
        (isCheckedChange)="toggleHTMLEnable($event,'enableThirdGroup')"
        >{{ assetConfig.enableThirdGroup ? "Enabled" : "Disabled" }}</ccl-toggle-button
    >
        </div>		
        <div style="clear:both"></div>
    </div>
<div *ngIf="assetConfig.enableThirdGroup">
<div class="c-form-group">
    <div class="c-form-group__label"><label for="filterLabel">Group Label</label></div>
    <input id="filterLabel" class="c-form-group__input" [(ngModel)]="assetConfig.thirdGroupLabel" cclFormInput maxlength="20" />
    <div class="c-form-group__hint">&nbsp;</div>
</div>
<div class="c-form-group__label"><label for="filterLabel">Assets</label></div>
<div class="c-form-group">
    <div class="c-form-group__label"><label for="displayOptionDropdown"></label></div>
    <div class="flex-100 w100">
        <div ngbDropdown class="d-inline-block w100">
            <button class="btn c-form-group__input text-left w100" id="displayOptionDropdown" ngbDropdownToggle>
                {{
                  assetConfig.thirdGroupList.length != 0
                        ? "Selected : " +
                        assetConfig.thirdGroupList.length + " " +
                        assetConfig.thirdGroupLabel
                        : "No File Selected"
                }}
            </button>
            <div
                ngbDropdownMenu
                aria-labelledby="displayOptionDropdown"
                class="w100 displayOptionDropdownContent"
                (click)="$event.stopPropagation()"
            >
                <div class="col-sm-12">
                    <div *ngIf="thirdAssetList.length > 0">
                        <div class="col-sm-12 plr0">
                            <ccl-checkbox
                                class="text-capitalize"
                                *ngFor="let field of thirdAssetList"
                                [hidden]="field.show == false"
                                buttonStyle="c-checkbox"
                                (clickEvent)="onChange(field,'thirdGroupList')"
                                [id]="field.key"
                                [value]="getIndex(assetConfig.thirdGroupList,field)"
                                >{{ field.label }}</ccl-checkbox
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="c-form-group__hint">&nbsp;</div>
</div>
<div class="c-form-group" *ngIf="assetConfig.thirdGroupList.length>0">
    <div class="flex-100 filterTypeContainer" ngxDroppable [model]="assetConfig.thirdGroupList">
        <div
            class="filterTypeContainerItem text-capitalize ngx-dnd-container"
            *ngFor="let field of assetConfig.thirdGroupList; let i = index"
            ngxDraggable
            [model]="field"
        >
            <span>{{
                field.label
            }}</span>
            <span (cclClick)="removeFields(i, assetConfig.thirdGroupList, 'thirdGroupList', field.value)"><i class="fa fa-remove removeIcon" title="Remove"></i></span>
            <span class="c-draghandle-icon filter-drag-icon" ngxDragHandle>
                <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
                <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
            </span>
        </div>
    </div>
    <div class="c-form-group__hint">&nbsp;</div>
</div>
</div>
</div>
</div>
